import { Icon56ErrorOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type ReactElement, memo, useCallback, useEffect } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import Content from 'reactApp/ui/Content/Content';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';

import styles from './PreOverquotaModal.css';
import type { PreOverquotaModalProps } from './PreOverquotaModal.types';
import { useContent, useTitle } from './useContent';

const ID = 'preoverquota-alert';

export const PreOverquotaModal = memo(function PreOverquotaModal({
    primaryButtonText = 'Снять ограничения',
    secondaryButtonText,
    onShow,
    onDismiss,
    onClick,
    onSecondaryClick,
    onClose,
}: PreOverquotaModalProps): ReactElement | null {
    useEffect(() => {
        onShow?.();
    }, [onShow]);

    const onPrimaryHandler = useCallback(() => {
        onClick?.();
        onClose?.();
    }, []);

    const onSecondaryHandler = useCallback(() => {
        onSecondaryClick?.();
        onClose?.();
    }, []);

    const onCloseHandler = useCallback(() => {
        onDismiss?.();
        onClose?.();
    }, [onDismiss]);

    return (
        <Dialog
            open
            header={''}
            closeOnDimmerClick={false}
            id={ID}
            qaId={ID}
            onCancel={onCloseHandler}
            className={classNames(styles.root)}
            size="tiny"
        >
            <Content isModal>
                <div className={styles.content}>
                    <div className={styles.imageWrapper}>
                        <Icon56ErrorOutline className={styles.imageIcon} />
                    </div>
                    <div className={styles.title}>{useTitle()}</div>
                    <div className={styles.text}>{useContent()}</div>
                    <div className={styles.footerWrapper}>
                        <Button
                            className={styles.button}
                            data-name="freeze-renewal"
                            theme="octavius"
                            sizeMode={ButtonSizeMode.small}
                            onClick={onPrimaryHandler}
                            primary
                        >
                            {primaryButtonText}
                        </Button>
                        {!!secondaryButtonText && (
                            <Button
                                className={styles.button}
                                data-name="secondary-bttn"
                                theme="octavius"
                                sizeMode={ButtonSizeMode.small}
                                onClick={onSecondaryHandler}
                            >
                                {secondaryButtonText}
                            </Button>
                        )}
                    </div>
                </div>
            </Content>
        </Dialog>
    );
});

PreOverquotaModal.displayName = 'PreOverquotaModal';
